<template>
  <div>
    <h1 class="qr-title">
      {{ $t('codes') }}
    </h1>
    <div class="qr-faq" v-if="!closed">
      <div class="qr-faq__title-wrap">
        <div class="qr-faq__title">
          {{ $t('faqTitle') }}
        </div>
        <img src="../assets/img/qr/qr-faq.png" alt="" class="qr-faq__image" />
      </div>
      <div>
        <div class="qr-faq__wrap">
          <div class="qr-faq__item">
            <div class="qr-faq__icon-wrap">
              <svg
                width="48"
                height="36"
                viewBox="0 0 48 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M47 29H29L27 31H22L19 29H1V31C1 33.2 2.8 35 5 35H43C45.2 35 47 33.2 47 31V29Z"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M44 29V3C44 1.9 43.1 1 42 1H6C4.9 1 4 1.9 4 3V29"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M12 8L14 10L18 6"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M12 15L14 17L18 13"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M12 22L14 24L18 20"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M21 8H35"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M21 15H35"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M21 22H35"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
              </svg>
            </div>
            <div>
              <div class="qr-faq__name">
                1. {{ $t('faqName1') }}
              </div>
              <div class="qr-faq__text">
                {{ $t('faqText1') }}
              </div>
            </div>
          </div>
          <div class="qr-faq__item">
            <div class="qr-faq__icon-wrap">
              <svg
                width="43"
                height="47"
                viewBox="0 0 43 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 14H17V19H22V14Z"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M33 14H28V19H33V14Z"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M22 25H17V30H22V25Z"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M33 25H28V30H33V25Z"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M25 13V17"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M19 22H16"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M25 19V22H21"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M27 22H31"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M25 24V28"
                  stroke="#1FC57F"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M1 42V5C1 2.8 2.8 1 5 1C7.2 1 9 2.8 9 5V41"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M33 43V46H5C2.8 46 1 44.2 1 42C1 39.8 2.8 38 5 38C7.2 38 9 39.8 9 42V43"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 5C9 3.3 10.3 2 12 2H42V39V40H12C10.3 40 9 41.3 9 43"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div>
              <div class="qr-faq__name">
                2. {{ $t('faqName2') }}
              </div>
              <div class="qr-faq__text">
                {{ $t('faqText2') }}
              </div>
            </div>
          </div>
          <div class="qr-faq__item">
            <div class="qr-faq__icon-wrap">
              <svg
                width="50"
                height="58"
                viewBox="0 0 50 58"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M43 23.6L42.8 23.4C41.9 22.5 41.7 21.3 42.3 20.8L44.7 18.5C45.6 17.7 47 17.7 47.8 18.7L48 18.9C48.9 19.8 48.9 21.2 48 22L45.6 24.3C45.1 24.8 43.9 24.5 43 23.6Z"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M19 57C19 57 20.9 55 22 54C30.2 54.6 33.2 49 34 48"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M43.6 42.3L43.4 42.2C42.5 41.5 42.2 40.4 42.7 39.9L44.7 37.6C45.4 36.8 46.7 36.7 47.6 37.4L47.8 37.5C48.7 38.2 48.8 39.5 48.1 40.4L46.1 42.7C45.6 43.2 44.5 43.1 43.6 42.3Z"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M20 50C22.2 43.8 20 38.2 18.1 35.7C18.9 33.2 19.3 31.5 19.5 28.5C19.7 26.8 18.9 25.4 18.2 24.4C17.4 23.3 15.6 23.6 15.2 24.8C13.6 30 13.3 31.5 12.2 34.1C11.1 37 11.7 41.2 11.2 42.4C11.2 42.6 9 46 9 46"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M43.6999 36.1L43.4999 36C42.5999 35.2 42.2999 34.2 42.7999 33.6L44.7999 31.3C45.4999 30.4 46.8999 30.4 47.6999 31.1L47.8999 31.2C48.7999 32 48.8999 33.3 48.1999 34.1L46.1999 36.4C45.6999 37 44.4999 36.8 43.6999 36.1Z"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M43.6999 29.9L43.4999 29.8C42.5999 29 42.2999 28 42.7999 27.4L44.7999 25.1C45.4999 24.2 46.8999 24.2 47.6999 24.9L47.8999 25C48.7999 25.8 48.8999 27.1 48.1999 27.9L46.1999 30.2C45.6999 30.8 44.4999 30.7 43.6999 29.9Z"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M29 45H32"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M44 19V4C44 2.3 42.7 1 41 1H20C18.3 1 17 2.3 17 4C17 6.9 17 24 17 24"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M20 48H41C42.7 48 44 46.7 44 45V43"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M20 57L7 44L2 49L10 57"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M7 49L8 50"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M21 42H43"
                  stroke="#1F85D7"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M28.3 15.4H23.9V19.8H28.3V15.4Z"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M38 15.4H33.6V19.8H38V15.4Z"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M28.3 25.1H23.9V29.5H28.3V25.1Z"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M38 25.1H33.6V29.5H38V25.1Z"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M31 14.5V18"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M25.7 22.4H23"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M31 19.8V22.4H27.4"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M32.7 22.4H36.2"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
                <path
                  d="M31 24.2V27.7"
                  stroke="#0A82D9"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
              </svg>
            </div>
            <div>
              <div class="qr-faq__name">
                3. {{ $t('faqName3') }}
              </div>
              <div class="qr-faq__text">
                {{ $t('faqText3') }}
              </div>
            </div>
          </div>
        </div>
        <div class="qr-faq__help">
          {{ $t('needHelp') }}: <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
        </div>
      </div>
      <VBtn
        icon
        small
        absolute
        top
        right
        @click="close"
        class="btn-close"
      >
        <Close />
      </VBtn>
    </div>
    <button class="qr-btn-add-list" @click="add">
      <svg
        class="qr-btn-add-list__icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#0A82D9" />
      </svg>
      <div class="qr-btn-add-list__name">
        {{ $t('addList') }}
      </div>
      <div class="qr-btn-add-list__text">
        {{ $t('addListText') }}
      </div>
    </button>
    <VacancyListItems />
  </div>
</template>

<script>
import VacancyListItems from '@/components/VacancyLists/VacancyListItems';
import Close from '@/components/SvgIcons/Close';
import { ref } from '@vue/composition-api';
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'VacancyLists',
  metaInfo() {
    return {
      title: this.$t('qrCodes'),
    };
  },
  components: { Close, VacancyListItems },
  setup(_, { root: { $router } }) {
    const closed = ref(localStorage.getItem('close-faq-qr'));
    return {
      add: () => {
        $router.push({ name: 'qr-add' });
      },
      close() {
        localStorage.setItem('close-faq-qr', true);
        closed.value = true;
      },
      closed,
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style lang="scss" scoped>
.qr-title {
  font-size: 1.5rem;
  line-height: 1.25;
  font-weight: 400;
  color: #212121;
  padding-top: 1.75rem;
  margin-bottom: 1.375rem;
}
.qr-faq {
  display: flex;
  padding: 1.4375rem 2.5rem 1.0625rem 2.125rem;
  background: #ebf0f7;
  color: #212121;
  border-radius: 0.625rem;
  margin-bottom: 1.25rem;
  position: relative;
  &__title-wrap {
    margin-right: 4.0625rem;
  }
  &__title {
    font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 2.4375rem;
  }
  &__wrap {
    display: flex;
    flex-grow: 2;
    justify-content: space-between;
  }
  &__help {
    margin-top: 20px;
  }
  &__item {
    max-width: 16.25rem;
    font-size: 0.875rem;
    line-height: 1.43;
    margin-right: 1.25rem;
    &:last-child {
      margin-right: 0;
    }
  }
  &__icon-wrap {
    width: 6.25rem;
    height: 5.625rem;
    background: #ffffff;
    border-radius: 0.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.9375rem;
  }
  &__name {
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
}
.qr-btn-add-list {
  width: 100%;
  padding: 1.875rem 1.875rem 2rem 3.75rem;
  margin-bottom: 1.25rem;
  border: 1px dashed #e0e0e0;
  border-radius: 0.625rem;
  text-align: left;
  position: relative;
  &__icon {
    position: absolute;
    top: 1.6875rem;
    left: 1.75rem;
  }
  &__name {
    font-size: 1.125rem;
    line-height: 1.111;
    color: #0a82d9;
    margin-bottom: 0.625rem;
  }
  &__text {
    font-size: 0.8125rem;
    line-height: 1.3;
    color: #757575;
  }
}
.btn-close {
  z-index: 2;
  top: 0.625rem;
  right: 0.625rem;
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .qr-btn-add-list {
    padding: 1.5rem 1.5rem 1.5rem 3rem;
    &__icon {
      width: 1.25rem;
      top: 1.25rem;
      left: 1.375rem;
    }
    &__name {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }
    &__text {
      font-size: 0.75rem;
    }
  }
  .btn-close {
    right: 0.5rem;
  }
  .qr-faq {
    display: block;
    &__title-wrap {
      margin-right: 2rem;
    }
    &__image {
      display: none;
    }
    &__title {
      margin-bottom: 1.25rem;
    }
    &__item {
      width: 13rem;
      margin-bottom: 0.75rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .qr-faq {
    padding: 1.5rem 1.25rem 0.5rem 1.25rem;
    &__title {
      font-size: 1rem;
      margin-bottom: 1rem;
    }
    &__wrap {
      display: block;
    }
    &__item {
      display: flex;
      align-items: center;
      width: 25rem;
      max-width: 100%;
      margin-bottom: 1rem;
    }
    &__icon-wrap {
      width: 5.25rem;
      min-width: 5.25rem;
      height: 5.25rem;
      margin: 0 1rem 0 0;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .qr-btn-add-list {
    padding: 1rem 1rem 1rem 2.25rem;
    &__icon {
      top: 0.875rem;
      left: 0.75rem;
    }
    &__name {
      font-size: 1rem;
      margin-bottom: 0.375rem;
    }
    &__text {
      font-size: 0.75rem;
    }
  }
  .qr-faq {
    padding: 1.5rem 1.25rem 0.5rem 1.25rem;
    &__item {
      align-items: flex-start;
    }
    &__icon-wrap {
      width: 4rem;
      min-width: 4rem;
      height: 4rem;
      padding: 0.625rem;
      margin: 0.25rem 1rem 0 0;
      svg {
        max-width: 2.75rem;
        max-height: 2.75rem;
      }
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
addList: Создать подборку
addListText: Создайте страницу с подборкой вакансий
faqTitle: Как это работает
faqName1: Выберите подходящие вакансии
faqText1: 'Вы создаёте страницу с подборкой вакансий, мы генерируем QR-код со ссылкой.'
faqName2: Разместите QR-код
faqText2: 'Размещаете сгенерированный QR-код на любые печатные материалы, например, на листовки, штендеры или баннеры.'
faqName3: Получайте отклики от кандидатов
faqText3: 'Ваши потенциальные сотрудники сканируют QR-код смартфоном и видят подборку вакансий.'
codes: Подборки вакансий с QR-кодами
needHelp: 'Нужна помощь в разработке и печати объявления? Мы можем сделать это за вас'
qrCodes: QR - коды
</i18n>
<i18n lang="yml" locale="en">
addList: Create job selection
addListText: Create job selection page
faqTitle: How it works
faqName1: Select relevant jobs
faqText1: 'You create a page with jobs. We generate a QR code with a link to it.'
faqName2: Print the QR-code
faqText2: 'Place the generated QR code on any of your materials, such as banners, cars, etc.'
faqName3: Find candidates
faqText3: 'Your potential employees scan the QR code and see your job selection.'
codes: 'Job selections & QR-codes'
needHelp: 'Need help with designing and printing your ad? We can do it for you'
qrCodes: QR codes
</i18n>
